<template>
  <div>
    <md-dialog :md-active.sync="isVisible" v-if="documents">
      <h5 :class="alert" v-if="isSubmitted" v-text="resultMessage"></h5>

      <md-dialog-title>
        Documents
      </md-dialog-title>

      <md-dialog-content>
        <div class="md-layout input-layout">
          <md-table v-model="documents">
            <md-table-row slot="md-table-row" slot-scope="{ item }" :style="{ 'background-color': getRowBackgroundColor(item) }">
              <md-table-cell md-label="Applicant" md-sort-by="applicant">{{ item.applicant | name }}</md-table-cell>
              <md-table-cell md-label="Document Type" md-sort-by="document_type">{{ item.document_type }}</md-table-cell>
              <md-table-cell md-label="File Name" md-sort-by="file_name">{{ item.file_name }}</md-table-cell>
              <md-table-cell md-label="Action">
                <span
                  v-if="submission_type == 'Finance One' && !isFileTypeAccepted(item)"
                  style="color: red; text-align: center;"
                > Unsupported File Type
                </span>
                <md-checkbox
                  v-model="item.selected"
                  v-else
                >
                </md-checkbox>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <loading-icon-text-button class="md-primary md-simple" @click="onCancel">Cancel</loading-icon-text-button>
        <loading-icon-text-button
          class="md-primary md-simple"
          @click="onUpload"
          icon="file_upload"
          :loading="uploading_documents"
          :class="{disabled:invalid}">
          Upload
        </loading-icon-text-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";

export default {
  components:{
    LoadingIconTextButton,
    ...ValidatedInputs,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    submission: {
      required: true,
      type: Object | Array,
    },
    value: {
      required: true,
      type: Object | Array,
    },
    emailFlag: {
      default: false,
      type: Boolean,
    },
    f1SupportedExt: {
      required: false,
      type: Array,
    },
    documents: {
      required: false,
      type: Object | Array,
    },
    submission_type: {
      required: false,
      type: String,
    }
  },
  watch:{
    submission() {
      if (this.submission && this.submission.uploaded_documents) {
        let uploaded_documents = this.submission.uploaded_documents;
        let that = this;
        uploaded_documents.forEach(id => {
          let indexOf = that.documents.findIndex(item => item.id === id)
          that.documents[indexOf].selected = true;
        });
      }
    }
  },
  data(){
    return{
      isSaving: false,
      isSubmitted: false,
      alert: 'upload_alert',
      resultMessage: '',
      selected_doucments: [],
      uploading_documents: false,
      invalid: false,
      supported_file_extensions: []
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      "application",
      "application_status",
      "productLenders",
      "products",
      "security",
    ]),
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      }
    },
    isVisible:{
      get(){
        return this.visible;
      },
      set(value){
        this.$emit("onCancel", value);
      }
    },
  },
  methods:{
    ...filters,
    onCancel() {
      this.isVisible = false;
      this.selected_doucments = [];
    },
    async onUpload() {
      this.uploading_documents = true;

      let payload = {
        submission: this.submission,
        application_id: this.application.loan.id,
        document_ids: this.documents.filter(item => item.selected).map(item=> item.id),
        emailFlag: this.emailFlag,
        lender: this.submission_type
      }

      try {
        let dispatchType = "upload_documents_to_lender";

        if(this.emailFlag){
          dispatchType = "submit_application_via_email";
        }

        await this.$store.dispatch(dispatchType, payload);

        if (['Finance One', 'Greenlight Auto' , 'Pepper Asset Finance (Consumer)' ,'Pepper Asset Finance (Commercial)'].includes(this.submission_type)) {
            this.$emit('successUpload');
        }

        this.isSubmitted = true;
        this.alert = 'upload_alert';
        this.resultMessage = 'The files have been submitted in the upload queue.';
        this.uploading_documents = false;
        this.isVisible = false;

        // todo it can be disappeared after 3 seconds
        // let that = this
        // setTimeout(function(){
        //   that.isSubmitted = false;
        // }, 3000);
      } catch (e) {
        console.error(e);
        this.isSubmitted = true;
        this.alert = 'upload_error';
        this.resultMessage = e.response.data;
        this.uploading_documents = false;
      }
    },
    reverseSubmit() {
      this.isSubmitted = !this.isSubmitted;
    },
    isFileTypeAccepted(item) {
      const fileExtension = item.file_name.slice(item.file_name.lastIndexOf('.')).toLowerCase();
      if (this.f1SupportedExt != null) {
        return this.f1SupportedExt.includes(fileExtension);
      } else {
        return true;
      }
    },
    getRowBackgroundColor(item) {
      if (!this.isFileTypeAccepted(item) && this.submission_type == 'Finance One') {
        return 'lightgray';
      } else {
        // no bg
        return '';
      }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
}
</script>
<style scoped>
.upload_alert {
  border: 0;
  position: relative;
  padding: 20px 15px;
  line-height: 20px;
  margin-bottom: 20px;
  z-index: 99999 !important;
  background-color: #0b0e3c;
  color: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
}

.upload_error {
  border: 0;
  position: relative;
  padding: 20px 15px;
  line-height: 20px;
  margin-bottom: 20px;
  z-index: 99999 !important;
  background-color: #e31854;
  color: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
}
</style>
